function formatDiff(diff: number): string {
  return diff >= 0 ? `+${diff}` : diff.toString();
}

function nullIfUndefined(val: any) {
  return val === undefined ? null : val;
}

function nullIfEmptyString(val: any) {
  return val === "" ? null : val;
}

function stringIsNullOrEmpty(val: any) {
  return val === undefined || val === null || val === "";
}

function stripHtml(value: string): any {
  return value.replace(/<.*?>/g, ""); // replace tags
}

function joinAssortmentGroupNames(row) {
  const { assortmentGroups } = row || {};
  if (assortmentGroups?.length > 0) {
    return assortmentGroups
      .filter((x) => x.name)
      .map((x) => {
        if (x.name) {
          return x.name;
        }
      })
      .join(", ");
  }

  return null;
}

// This function is used to convert the accept string from the file input to a more user-friendly format
function addFileExtensions(accept: string) {
  return accept.split(",").map((ext) => ext.trim().replace("image/", " ."));
}

// Returns the enum member name for a given value
function getEnumName(enumObj: any, value: number): string | undefined {
  return Object.keys(enumObj).find(key => enumObj[key] === value);
}

export {
  formatDiff,
  nullIfUndefined,
  nullIfEmptyString,
  stringIsNullOrEmpty,
  joinAssortmentGroupNames,
  stripHtml,
  addFileExtensions,
  getEnumName
};
